import { registerLocale, setDefaultLocale } from 'react-datepicker';
import daLocale from 'date-fns/locale/da';

export function initializeLocale() {
  const daLocaleId = 'da-dk';
  registerLocale(daLocaleId, daLocale);
  setDefaultLocale(daLocaleId);
}
